import { Approvers, Issuers } from "~/infrastructure/api/dtos";
import type { City } from "./City.type";
import { SettingParameter } from "./SettingParameter.type";
import type { State } from "./State.type";

type AdditionalInfoEntry = {
  obs: string;
};

export type AdditionalInfo = {
  [key: string]: AdditionalInfoEntry;
};

export type InvoiceEmissionByProduct = {
  airway: boolean;
  hotel: boolean;
  vehicle: boolean;
  road: boolean;
};

export const DEFAULT_INVOICE_EMISSION_BY_PRODUCT: InvoiceEmissionByProduct = {
  airway: false,
  hotel: false,
  vehicle: false,
  road: false,
};

export type Customer = {
  uuid: string;
  companyName: string;
  tradingName: string;
  cnpj: string;
  stateRegistration: string;
  phone: string;
  email: string;
  notificationEmails?: string[] | null;
  integrationId: string;
  wintourCode: string;
  flightManager: string;
  zipCode: string;
  address: string;
  number: string;
  district: string;
  state: State;
  city: City;
  isActive: boolean;
  fraudBlocking: boolean;
  additionalInfo: AdditionalInfo;
  issuers: Issuers[];
  approvers: Approvers[];
  invoiceLimit: number;
  dashboardLink?: string;
  expenseEmail?: string;
  financialEmail?: string;
  settingsParameters: SettingParameter[];
  agency: {
    uuid: string;
    name: string;
    email: string;
    phone: string;
  };
  markupId: string;
  feeId: string;
  markdownId: string;
  domains: { domain: string }[];
  invoiceEmissionByProduct: InvoiceEmissionByProduct;
};
